import React from 'react';
import { Play } from 'lucide-react';
import { services } from '../mock';

const Services = ({ onPlay }) => {
  return (
    <section id="services" className="py-24 md:py-28 bg-[#0c0c0c] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-14">
          <p className="font-display tracking-[0.35em] text-[#c9a85f] text-sm uppercase mb-5">What We Do</p>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl uppercase leading-[1.05]">
            Content your audience actually wants to see
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const playable = Boolean(s.youtubeId);
            const Tag = playable ? 'button' : 'div';
            return (
              <Tag
                key={s.id}
                onClick={playable ? () => onPlay(s.youtubeId, s.title) : undefined}
                data-testid={`service-card-${s.id}`}
                className="group relative rounded-2xl overflow-hidden border border-white/10 bg-[#111] hover:border-[#c9a85f]/50 transition-colors text-left flex flex-col"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-[#111]/30 to-transparent" />
                  {playable && (
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#c9a85f]/90 text-black group-hover:scale-110 transition-transform shadow-xl">
                        <Play size={20} className="fill-black ml-1" />
                      </span>
                    </span>
                  )}
                </div>
                <div className="p-7">
                  <h3 className="font-display font-bold text-white text-2xl uppercase">{s.title}</h3>
                  <p className="text-[#c9a85f] text-sm mt-2 font-medium">{s.tagline}</p>
                  <p className="text-white/75 text-sm md:text-base font-normal mt-4 leading-relaxed">{s.desc}</p>
                </div>
                <div className="h-1 w-0 bg-[#c9a85f] group-hover:w-full transition-all duration-500 mt-auto" />
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
